import { FlexBox, Icon, Page, TabItem, Tabs } from '@dixa/lib-shared-habla';
import noop from 'lodash/noop';
import { useMemo } from 'react';

import { AppLink } from 'components/appLink';

import { SettingsAgentsRoleForm } from '../../components/form/settingsAgentsRoleForm';
import { SettingsAgentsRoleTab } from '../../settingsAgentsRoles.types';

export const SettingsAgentsRolesCreateView = (): JSX.Element => {
  const tabs = useMemo(
    (): (TabItem & { id: SettingsAgentsRoleTab })[] => [
      { id: 'permissions', label: 'Role permissions' },
      { id: 'agents', label: 'Agents', disabled: true },
    ],
    [],
  );

  const selectedTab: SettingsAgentsRoleTab = 'permissions';

  return (
    <Page>
      <Page.Head
        title={
          <FlexBox gap="200" alignItems="center">
            <AppLink path="/settings/agents" style={{ color: 'inherit' }}>
              Agents
            </AppLink>
            <Icon name="angle-right" />
            <AppLink path="/settings/agents/roles" style={{ color: 'inherit' }}>
              Roles
            </AppLink>
            <Icon name="angle-right" />
            Create custom role
          </FlexBox>
        }
      />

      <Page.Tabs>
        <Tabs selectedId={selectedTab} tabs={tabs} onChange={noop} />
      </Page.Tabs>

      <Page.Body>
        <SettingsAgentsRoleForm />
      </Page.Body>
    </Page>
  );
};
